module.exports = __webpack_public_path__ + "img/relevance.bd25d12a.svg";